import styled, {css} from 'styled-components'
import { Mkt04responsiveWidth } from '.';
import check from 'src/assets/images/mkt04/check.svg'
import checkbox from 'src/assets/images/mkt04/checkbox.svg'
import nonCheck from 'src/assets/images/mkt04/nonCheck.svg'
import nonCheckbox from 'src/assets/images/mkt04/nonCheckbox.svg'
import termsChevron from 'src/assets/images/mkt04/termsChevron.svg'

const ICONS = {
  all:  { on: checkbox,  off: nonCheckbox },
  each: { on: check,     off: nonCheck    },
} as const;
type IconVariant = keyof typeof ICONS;

export const TermsAgreeWrap = styled.div<{$dim?: boolean }>`
  ${Mkt04responsiveWidth};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 30px;
  box-sizing: border-box;
  padding: 0 16px;
    ${({ $dim }) => $dim && css`
  opacity: 0.3;
  transition: opacity .2s ease;
  `}
`

export const AllTermsContainer = styled.label`
  display: flex;
  align-items: center;
  width:100%;
  height: 50px;
  padding: 15px 16px;
  gap: 10px;
  flex: 1 0 0;
  cursor: pointer;
  border-radius: 12px;
  background: #FAFAFA;
  margin-bottom: 12px;
  p {
    color: #666666;
    font-family: ${({ theme }) => theme.fontFamily};
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
  }
`;

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
`;

export const EachTermsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const EachTermsItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 16px;
  box-sizing: border-box;
`;

export const CheckLabel = styled.label`
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:has(${HiddenCheckbox}:focus-visible) {
    outline: 2px solid #1a6eff;
    outline-offset: 2px;
    border-radius: 4px;
  }
`;


export const CheckIcon = styled.span<{ checked: boolean; variant: IconVariant }>`
  width: 24px; height: 24px; flex: 0 0 24px;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: ${({ checked, variant }) =>
    `url(${checked ? ICONS[variant].on : ICONS[variant].off})`};

  ${HiddenCheckbox}:focus-visible + & {
    outline: 2px solid #1a6eff;
    outline-offset: 2px;
    border-radius: 4px;
  }
`;
export const Accordion = styled.div`
  width: 100%;
`;
export const TermsTitleWrap = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
`
export const TermsTitle = styled.p`
  font-size: 10px;
  font-weight: 500;
  color: #717580;
  text-align: left;
`;

export const AccordionChevron = styled.span<{ $open: boolean }>`
  width: 16px;
  height: 16px;
  background: url(${termsChevron}) center / contain no-repeat;
  transform: rotate(${p => (p.$open ? '180deg' : '')});
  transition: transform 0.2s ease;
`;
export const Chevron = styled.span`
  width: 16px;
  height: 16px;
  background: url(${termsChevron}) center / contain no-repeat;
  transform: rotate(-90deg);
  transition: transform 0.2s ease;
`;

export const AccordionPanel = styled.div`
  width:100%;
  padding-left: 16px;
  box-sizing: border-box;
`;

export const ChevronButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 0;
  background: transparent;
  cursor: pointer;
`;

